(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8435],{

/***/ 32056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | TRIAL Holdings, Inc.") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 61842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Index; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27812);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66261);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var Index = function Index(_ref) {
  var links = _ref.links,
      listType = _ref.listType,
      columnGap = _ref.columnGap;

  // ナンバリングのスタート値を計算する
  var setStartValue = function setStartValue(index) {
    var count = 0;
    if (index === 0) return count;

    (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Array(index)).map(function (_, i) {
      return count += links[i].length;
    });

    return count;
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Wrapper, {
    columnGap: columnGap,
    children: links.map(function (arr, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(List, {
        startValue: setStartValue(index),
        listType: listType,
        as: listType === 'disc' ? 'ul' : '',
        children: arr.map(function (_ref2) {
          var name = _ref2.name,
              anchor = _ref2.anchor;
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
            "data-list-type": listType,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_scroll__WEBPACK_IMPORTED_MODULE_0__/* .Link */ .rU, {
              to: anchor,
              smooth: true,
              offset: -105,
              children: name
            })
          }, name);
        })
      }, "".concat(arr.toString()).concat(index));
    })
  });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Index__Wrapper",
  componentId: "sc-19oeg9l-0"
})(["border:1px solid #707070;padding:30px 25px 25px;display:flex;column-gap:", "px;@media screen and (max-width:1047px){flex-direction:column;padding:30px 20px 27px;}"], function (_ref3) {
  var columnGap = _ref3.columnGap;
  return columnGap;
});
var ListStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["color:", ";counter-increment:number;"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var List = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ol.withConfig */ .ZP.ol.withConfig({
  displayName: "Index__List",
  componentId: "sc-19oeg9l-1"
})(["letter-spacing:0.32px;counter-reset:", ";li{line-height:26px;letter-spacing:0.3px;&:hover{opacity:0.7;cursor:pointer;}&[data-list-type='number']::before{", ";content:counter(number) '. ';}&[data-list-type='roman']::before{", ";content:counter(number,upper-roman) '. ';}&[data-list-type='article']::before{", ";content:'' counter(number) '.';}&[data-list-type='disc']::before{content:'';width:6px;height:6px;border-radius:50%;background-color:", ";display:inline-block;margin-right:0.5em;transform:translateY(-50%);}}a{color:", ";}@media screen and (max-width:1047px){li{font-size:15px;}}"], function (_ref4) {
  var startValue = _ref4.startValue,
      listType = _ref4.listType;
  return listType !== 'disc' ? "number ".concat(startValue) : '';
}, ListStyle, ListStyle, ListStyle, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 73799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SectionTitleDiv, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleDiv, {
        children: children
      })
    })
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-1mt88t8-0"
})(["display:flex;flex-direction:column;row-gap:10px;text-align:center;font-weight:bold;color:", ";@media screen and (max-width:1047px){color:", ";}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle);
var FontStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(["font-size:26px;letter-spacing:0;"]);
var TitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__TitleDiv",
  componentId: "sc-1mt88t8-1"
})(["h2{font-weight:bold;font-size:40px;letter-spacing:1.6px;line-height:50px;span{font-size:30px;letter-spacing:1.2px;}}@media screen and (max-width:1047px){h2{line-height:37px;", " span{", "}}}"], FontStyle, FontStyle);

/***/ }),

/***/ 91465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$V": function() { return /* binding */ SectionDiv; },
/* harmony export */   "CK": function() { return /* binding */ StyledList; },
/* harmony export */   "JP": function() { return /* binding */ GridTable2; },
/* harmony export */   "Jn": function() { return /* binding */ GridRow; },
/* harmony export */   "R1": function() { return /* binding */ GridTable; },
/* harmony export */   "U5": function() { return /* binding */ SummaryDiv; },
/* harmony export */   "ZB": function() { return /* binding */ ZenkakuSpace; },
/* harmony export */   "_b": function() { return /* binding */ StyledListInGridRow; },
/* harmony export */   "eX": function() { return /* binding */ StyledH3; },
/* harmony export */   "oH": function() { return /* binding */ StyledListItem; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["color:", ";text-decoration:underline;"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var SummaryDiv = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__SummaryDiv",
  componentId: "sc-1vdak17-0"
})(["text-align:left;font-size:16px;color:", ";font-weight:400;line-height:26px;letter-spacing:0.32px;a{", "}@media screen and (max-width:1047px){font-size:15px;line-height:25px;letter-spacing:0.3px;}"], function (_ref) {
  var color = _ref.color;
  return color === undefined ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : color;
}, StyledLink);
var H3Style = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["font-size:22px;color:", ";font-weight:bold;line-height:30px;letter-spacing:0.88px;@media screen and (max-width:1047px){font-size:15px;letter-spacing:0.6px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var StyledH3 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "TextStyle__StyledH3",
  componentId: "sc-1vdak17-1"
})(["", ""], H3Style);
var SectionDiv = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__SectionDiv",
  componentId: "sc-1vdak17-2"
})(["width:100%;display:flex;flex-direction:column;row-gap:24px;text-align:left;font-size:16px;color:", ";font-weight:400;line-height:26px;letter-spacing:0.32px;h3{", "}ul{li{max-width:", ";}}ol{padding-left:25px;list-style-type:decimal;}li{span{display:block;font-weight:bold;}}p{span{font-weight:bold;}}a{", "}@media screen and (max-width:1047px){row-gap:30px;font-size:14px;line-height:24px;letter-spacing:0.28px;ul{li{width:100%;}}}"], function (_ref2) {
  var color = _ref2.color;
  return color === undefined ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : color;
}, H3Style, function (_ref3) {
  var liWidth = _ref3.liWidth;
  return liWidth === undefined ? '100%' : "".concat(liWidth, "px");
}, StyledLink);
var GridTable = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridTable",
  componentId: "sc-1vdak17-3"
})(["width:100%;display:grid;grid-template-columns:25% 25% 25% 25%;grid-template-rows:auto;border-top:1px solid #707070;border-left:1px solid #707070;@media screen and (max-width:1047px){grid-template-columns:50% 50%;}"]); // カラムが６つのテーブル、テーブル内の文章が単語関係なく改行

var GridTable2 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridTable2",
  componentId: "sc-1vdak17-4"
})(["width:100%;display:grid;grid-template-columns:repeat(6,16.6666667%);grid-template-rows:auto;border-top:1px solid #707070;border-left:1px solid #707070;word-break:break-all;"]);
var GridRow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridRow",
  componentId: "sc-1vdak17-5"
})(["width:100%;display:contents;border-bottom:1px solid #707070;div{border-bottom:1px solid #707070;border-right:1px solid #707070;padding:20px 20px;}@media screen and (max-width:1047px){margin:0px 20px;div{padding:16px 20px 18px;}}"]);
var StyledList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "TextStyle__StyledList",
  componentId: "sc-1vdak17-6"
})(["counter-reset:number ", ";max-width:", ";margin-left:", ";@media screen and (max-width:1047px){width:100%;margin-left:0;padding-left:", ";}"], function (_ref4) {
  var startValue = _ref4.startValue;
  return startValue === undefined ? '' : startValue;
}, function (_ref5) {
  var liWidth = _ref5.liWidth;
  return liWidth === undefined ? '100%' : "".concat(liWidth, "px");
}, function (_ref6) {
  var marginLeft = _ref6.marginLeft;
  return marginLeft === undefined ? '0' : "".concat(marginLeft, "em");
}, function (_ref7) {
  var paddingLeft = _ref7.paddingLeft;
  return paddingLeft === undefined ? '0' : "".concat(paddingLeft, "em");
});
var StyledListInGridRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(StyledList).withConfig({
  displayName: "TextStyle__StyledListInGridRow",
  componentId: "sc-1vdak17-7"
})(["padding-left:0.8em;"]);
var Article = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:1.5em;text-indent:-2.5em;::before{counter-increment:number;content:'\uFF08' counter(number) '\uFF09';}"]);
var BoldArticle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:1.5em;text-indent:-2.5em;font-weight:bold;p{text-indent:0em;font-weight:400;}::before{counter-increment:number;content:'\uFF08' counter(number) '\uFF09';}"]);
var Disc = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["text-indent:-1em;::before{counter-increment:number;content:'\u30FB';}"]);
var Comment = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:0.5em;text-indent:-3.5em;::before{counter-increment:number;content:'\uFF08Note' counter(number) '\uFF09';}@media screen and (max-width:1047px){text-indent:-0.5em;}"]);
var Number = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:0.5em;text-indent:-1.5em;::before{counter-increment:number;content:counter(number) '. ';}"]);
var StyledListItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "TextStyle__StyledListItem",
  componentId: "sc-1vdak17-8"
})(["font-weight:400;", " ", ";", ";"], function (_ref8) {
  var listType = _ref8.listType;

  switch (listType) {
    case 'article':
      return Article;

    case 'disc':
      return Disc;

    case 'comment':
      return Comment;

    case 'boldArticle':
      return BoldArticle;

    case 'number':
      return Number;

    case undefined:
      break;
  }
}, function (_ref9) {
  var paddingLeft = _ref9.paddingLeft;
  return paddingLeft && "padding-left:".concat(paddingLeft, "em");
}, function (_ref10) {
  var textIndent = _ref10.textIndent;
  return textIndent && "text-indent:".concat(textIndent, "em");
});
var ZenkakuSpace = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TextStyle__ZenkakuSpace",
  componentId: "sc-1vdak17-9"
})(["padding-left:", ";"], function (_ref11) {
  var space = _ref11.space;
  return space === undefined ? '1em' : "".concat(space, "em");
});

/***/ }),

/***/ 33286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ SNSPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/enpages/Legal/TextStyle.tsx
var TextStyle = __webpack_require__(91465);
// EXTERNAL MODULE: ./src/components/elements/LinkText/index.tsx
var LinkText = __webpack_require__(41705);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enpages/Legal/SNSPolicy/SNSItems.tsx





var snsItems = [{
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "1. General Provisions"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["TRIAL Group Social Media Official Account Terms of Use (hereinafter referred to as 'these terms') specify the matters that users of the social media official accounts operated by TRIAL Group (TRIAL Holdings, Inc. and its group companies *) and the associated services (hereinafter collectively referred to as 'this service') must adhere to in using this service (including viewing activities, as similarly defined below).", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "*Group companies of TRIAL Holdings, Inc. can be found", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
        path: "/en/company/overview/",
        text: "here"
      }), "."]
    })]
  }),
  id: 'policy1'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "2. Scope of these Terms"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "These terms apply to all users of this service."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "If a user use this service, it is considered that they have accepted these terms."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Various provisions that TRIAL Group presents at any time online or through other means constitute part of these terms. However, if these provisions differ from these terms, the provisions take precedence."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "In the event of any conflict between these terms and the terms of use or policies established by each social media operating company that provides this service, the user shall adhere to the terms and policies of the respective social media operating company."
      })]
    })]
  }),
  id: 'policy2'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "3. Handling of User information"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: ["Personal information that users register with TRIAL Group will be held by TRIAL Group, and it will not be provided to third parties without the user's consent. The registered personal information will only be used for the purposes specified in TRIAL Group's", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
          path: "/en/legal/privacy-policy/",
          text: "privacy policy"
        }), "."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "TRIAL Group will access information that users have set to be public for all users in this service."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "If a user uses this service, it is considered that they have agreed to the privacy policy established by TRIAL Group."
      })]
    })]
  }),
  id: 'policy3'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "4. Amendment of these Terms"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "TRIAL Group may change these terms without the consent of users. The amended terms will take effect from the time TRIAL Group displays them online."
    })]
  }),
  id: 'policy4'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "5. Prohibited Acts"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "When using this service, the following actions are prohibited:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Acts that infringe upon the copyrights, portrait rights, or other intellectual property rights of TRIAL Group, other users, or third parties, or acts that may have such implications."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Acts that infringe upon the property, credibility, privacy, etc., of TRIAL Group, other users, or third parties, or acts that may have such implications."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Defamatory or slanderous acts against TRIAL Group, other users, or third parties, regardless of truth."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Sending, transmitting, disclosing, copying, or posting personal information (email addresses, addresses, phone numbers, and other private information) of TRIAL Group and individuals without the prior consent of TRIAL Group or the individual."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Sending, disclosing, copying, or posting the copyrighted works of other users or third parties without the prior consent of TRIAL Group."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Acts that hinder or destroy the operation of TRIAL Group through viruses, hacking, etc."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Threats, obscenity, defamation, discriminatory acts, political activities, religious activities, or acts related to these."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Unauthorized access to computers using borrowed names or addresses."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Business activities, recruitment activities, or affiliate activities without the prior permission of TRIAL Group."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Acts that hinder the operation of this service or TRIAL Group, acts that undermine the trust of TRIAL Group, or acts that disadvantage other users or TRIAL Group."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Acts contrary to public order and morals, criminal acts, or acts closely related to them."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Acts that violate laws or regulations or are closely related to such violations."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Providing or attempting to provide obscene images, audio, text, or similar content."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Displaying advertising banners, including all types of banner exchanges or link exchanges."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Posting or endorsing content that may violate pharmaceutical affairs laws."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Acts prohibited by each social media operating company."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Any acts contrary to the purpose of this service."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Other acts deemed inappropriate by TRIAL Group."
      })]
    })]
  }),
  id: 'policy5'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "6. Measures Against Prohibited Acts"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Regardless of intention or negligence, if TRIAL Group determines that a user has engaged in or may engage in any of the acts listed in the preceding article, TRIAL Group may take one or a combination of the following measures without prior notice:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Deletion of comments or posted content."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Restriction of the use of the service."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Warnings or advice through messages or private messages within the platform page."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Announcement of the measures taken through messages or private messages within the platform page regarding the actions in (1) to (3)."
      })]
    })]
  }),
  id: 'policy6'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "7. Changes to the Service"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "TRIAL Group will provide this service to users based on separate provisions and individual regulations in addition to these terms. TRIAL Group may change the content of this service (including discontinuation) without the consent of the user."
    })]
  }),
  id: 'policy7'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "8. Intellectual Property Rights"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "All rights related to copyrights, trademark rights, service marks, patent rights, or other ownership rights, as well as rights protected by law, for all content provided by TRIAL Group in this service, including text, software, music, audio, photos, graphics, videos, page layouts, designs, and other materials, belong to TRIAL Group."
    })]
  }),
  id: 'policy8'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "9. Use by TRIAL Group"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "The information such as comments, images, and videos posted by users may be used by TRIAL Group for the purposes of advertising, promotion, and encouraging use in print materials, newsletters, websites, etc., without obtaining the individual's consent."
    })]
  }),
  id: 'policy9'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "10. Resolution of Disputes"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "In the case of matters not stipulated in these terms, ambiguity in the interpretation of these terms, or if a dispute arises between the user and TRIAL Group, both parties agree to resolve the dispute in good faith."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "In the event that litigation becomes necessary between the user and TRIAL Group, the court with jurisdiction over the headquarters of TRIAL Holdings, Inc., shall be the exclusive agreed jurisdictional court for the first instance."
      })]
    })]
  }),
  id: 'policy10'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "11. Disclaimer"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "TRIAL Group does not provide any legal guarantee or assume any responsibility for the accuracy, usefulness, currency, appropriateness, etc., of all information provided by users to all users of this service."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "The use of this service may be affected by the user's browser and viewing environment. TRIAL Group shall not be responsible for any damages arising from the user's inability to use this service."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Social media platforms are operated by external corporations, and TRIAL Group does not guarantee their functionality or safety. TRIAL Group also cannot provide answers regarding the operation of external corporate social media, the functionality of software and mobile applications, how to use them, or technical inquiries."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "TRIAL Group is not responsible for any damage caused to users by using sites other than TRIAL Group linked from this service (hereinafter referred to as \"linked sites\"). TRIAL Group is not responsible for the content of linked sites or the handling of personal information on it. Even if a linked site is interrupted or stopped, TRIAL Group assumes no responsibility for any damages incurred by users."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Not all posts and comments will receive a response."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "Official announcements and views of TRIAL Group are made on TRIAL Group's website and through press releases, among other channels. Information posted by TRIAL Group and its employees on this service does not necessarily represent the official announcements or views of TRIAL Group. Additionally, user-generated content posted by users may not reflect the opinions or ideals of TRIAL Group and its employees and affiliates. TRIAL Group does not guarantee the accuracy of statements or claims made on this service."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "If TRIAL Group deems any information posted by users on this service as inappropriate, TRIAL Group may, at its discretion, delete such information without disclosing the reasons to the user. However, TRIAL Group does not guarantee that it will monitor or inspect the information posted by users on this service based on the provisions of this section."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "TRIAL Group shall not be held responsible for any damages caused or related to a user's use of this service that affects other users or third parties, or damages caused or related to a third party's viewing of this service that affects the user (including cases where a malicious third party collects personal information through any means, leading to damages incurred by the user)."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "TRIAL Group does not provide any guarantee regarding the quality or performance of this service to users. Additionally, TRIAL Group assumes no responsibility for the temporary suspension, cessation, defects, and any losses or damages arising from or related to them."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "TRIAL Group may, after providing prior notice online, terminate or delete part or all of this service. TRIAL Group shall be exempt from liability for damages incurred by users and third parties due to the termination of this service."
      })]
    })]
  }),
  id: 'policy11'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["Date of Enactment:", /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* ZenkakuSpace */.ZB, {}), "June 23,2020", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Date of Last Revision:", /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* ZenkakuSpace */.ZB, {}), "December 26,2022"]
    })
  }),
  id: 'signdate'
}];
var snsLinks = [[{
  name: '（General Provisions）',
  anchor: 'policy1'
}, {
  name: '（Scope of these Terms）',
  anchor: 'policy2'
}, {
  name: '（Handling of User information）',
  anchor: 'policy3'
}], [{
  name: '（Amendment of these Terms）',
  anchor: 'policy4'
}, {
  name: '（Prohibited Acts）',
  anchor: 'policy5'
}, {
  name: '（Measures Against Prohibited Acts）',
  anchor: 'policy6'
}], [{
  name: '（Changes to the Service）',
  anchor: 'policy7'
}, {
  name: '（Intellectual Property Rights）',
  anchor: 'policy8'
}, {
  name: '（Use by TRIAL Group）',
  anchor: 'policy9'
}], [{
  name: '（Resolution of Disputes）',
  anchor: 'policy10'
}, {
  name: '（Disclaimer）',
  anchor: 'policy11'
}]];
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/enlayout.tsx + 7 modules
var enlayout = __webpack_require__(34591);
// EXTERNAL MODULE: ./src/components/enlayouts/Head/index.tsx
var Head = __webpack_require__(32056);
// EXTERNAL MODULE: ./src/components/enlayouts/Legal/Index/index.tsx
var Index = __webpack_require__(61842);
// EXTERNAL MODULE: ./src/components/enlayouts/Legal/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(73799);
;// CONCATENATED MODULE: ./src/components/enpages/Legal/SNSPolicy/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var sectionTitle = {
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
    children: "Social Media Policy"
  })
};
var SNSPage = function SNSPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "Social Media Policy",
      description: "The SNS policy for TRIAL Holdings, Inc.",
      ogp: {
        type: 'article',
        url: 'en/legal/sns-policy/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SnsContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, _objectSpread({}, sectionTitle)), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 70,
          sp: 60
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Index/* Index */.g, {
        columnGap: 25,
        listType: "article",
        links: snsLinks
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 70,
          sp: 39
        }
      }), snsItems.map(function (_ref, index) {
        var children = _ref.children,
            id = _ref.id;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* SectionDiv */.$V, {
            id: id,
            children: children
          }), index < snsItems.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              pc: 70,
              sp: 39
            }
          })]
        }, "".concat(id).concat(index));
      })]
    })]
  });
};

SNSPage.getLayout = function (page) {
  var pageTitle = {
    title: 'Legal',
    subTitle: ''
  };
  var breadCrumbs = [{
    name: 'Home',
    path: '/en/'
  }, {
    name: 'Legal',
    path: '/en/legal/'
  }, {
    name: 'Social Media Policy',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(enlayout/* TitleLayout */.$0, _objectSpread(_objectSpread({}, pageTitle), {}, {
    breadCrumbs: breadCrumbs,
    isRequiredBackground: false,
    children: page
  }));
};

var SnsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SNSPolicy__SnsContainer",
  componentId: "sc-jbhipq-0"
})(["width:1040px;padding-top:62px;padding-bottom:130px;margin:0 auto;@media screen and (max-width:1047px){width:100%;padding:40px 20px 70px;}"]);
;// CONCATENATED MODULE: ./src/pages/en/legal/sns-policy.tsx


/***/ }),

/***/ 4052:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/legal/sns-policy",
      function () {
        return __webpack_require__(33286);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,8517,4591,9774,2888,179], function() { return __webpack_exec__(4052); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);